'use client';

import CountUp from 'react-countup';
import type { CountUpProps } from 'react-countup/build/CountUp';
import { toDP } from '@/libs/decimal';

interface TruncatedCountUpProps extends Omit<CountUpProps, 'start' | 'end' | 'decimals'> {
  start?: number;
  end: number;
  maxDecimals?: number;
}

const truncateDecimals = (num: number, maxDecimals: number) => toDP(num, maxDecimals);

const getDynamicDecimals = (num: number, maxDecimals: number) => {
  if (Number.isInteger(num)) return 0;
  const decimalLen = num.toString().split('.')[1]?.length ?? 0;
  return Math.min(decimalLen, maxDecimals);
};

export default function TruncatedCountUp({
  start = 0,
  end,
  maxDecimals = 2,
  ...props
}: TruncatedCountUpProps) {
  const displayStart = truncateDecimals(start, maxDecimals);
  const displayEnd = truncateDecimals(end, maxDecimals);

  return (
    <CountUp
      {...props}
      start={displayStart}
      end={displayEnd}
      decimals={getDynamicDecimals(displayEnd, maxDecimals)}
    />
  );
}
